import { createTheme } from '@mui/material/styles';

/**
 * PetSnap 'Golden Hour Grace' Theme
 * Warm, organic, and friendly.
 */

const goldenHourPalette = {
    canvas: '#FFFDF9', // Warm Cream Background
    surface: '#FFFFFF', // Pure White Card
    elevated: '#FDF6E3', // Soft Beige
    honey: '#F4A261', // Primary Golden
    forest: '#264653', // Deep Teal Text
    meadow: '#48B0A5', // Soft Green
    terracotta: '#E76F51', // Warm Error
    sky: '#87CEEB', // Info Blue
    text: {
        primary: '#264653',
        secondary: '#5F7D8B',
        tertiary: '#9E9E9E'
    }
};

export const petSnapTheme = createTheme({
    palette: {
        mode: 'light', // CRITICAL: Switching to Light Mode
        primary: {
            main: goldenHourPalette.honey,
            light: '#FFD8A8',
            dark: '#E76F51',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: goldenHourPalette.meadow,
            light: '#8CE0D8',
            dark: '#2A9D8F',
            contrastText: '#FFFFFF'
        },
        background: {
            default: goldenHourPalette.canvas,
            paper: goldenHourPalette.surface
        },
        text: {
            primary: goldenHourPalette.text.primary,
            secondary: goldenHourPalette.text.secondary,
            disabled: goldenHourPalette.text.tertiary
        },
        error: {
            main: goldenHourPalette.terracotta
        },
        warning: {
            main: '#FFB703' // Sunny Yellow
        },
        info: {
            main: goldenHourPalette.sky
        },
        success: {
            main: goldenHourPalette.meadow
        },
        divider: 'rgba(38, 70, 83, 0.08)' // Soft Teal Divider
    },
    typography: {
        fontFamily: "'Inter', sans-serif",
        h1: { fontFamily: "'Outfit', sans-serif", fontWeight: 700 },
        h2: { fontFamily: "'Outfit', sans-serif", fontWeight: 600 },
        h3: { fontFamily: "'Outfit', sans-serif", fontWeight: 600 },
        h4: { fontFamily: "'Outfit', sans-serif", fontWeight: 500 },
        h5: { fontFamily: "'Outfit', sans-serif", fontWeight: 500 },
        h6: { fontFamily: "'Outfit', sans-serif", fontWeight: 500 },
        button: { fontFamily: "'Outfit', sans-serif", fontWeight: 600, textTransform: 'none' },
    },
    shape: {
        borderRadius: 16 // Softer, friendlier corners
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: 'none',
                    padding: '10px 24px',
                    transition: 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)', // Bouncy
                    '&:hover': {
                        transform: 'scale(1.02)',
                        boxShadow: '0 4px 12px rgba(244, 162, 97, 0.2)'
                    },
                    '&:active': {
                        transform: 'scale(0.98)'
                    }
                },
                containedPrimary: {
                    background: 'linear-gradient(135deg, #F4A261 0%, #E76F51 100%)', // Golden Hour Gradient
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 4px 20px rgba(38, 70, 83, 0.06)', // Diffused Light
                    borderRadius: 20,
                    border: '1px solid rgba(38, 70, 83, 0.04)'
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 16
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 12,
                        backgroundColor: '#FCFCFC',
                        '& fieldset': {
                            borderColor: 'rgba(38, 70, 83, 0.1)',
                        },
                        '&:hover fieldset': {
                            borderColor: goldenHourPalette.honey,
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: goldenHourPalette.honey,
                            borderWidth: 2
                        }
                    }
                }
            }
        }
    }
});

export default petSnapTheme;
